<template>
  <div class="buy-bottom">
    <div class="item-con">
      <!--<div class="item clickable">
        <img class="icon icon1" src="./img/consult.png" alt="">
        <span class="text">咨询</span>
      </div>-->
      <div class="item clickable" @click="goMallShop">
        <img class="icon icon2" src="./img/enterShop.png" alt="">
        <span class="text">进店</span>
      </div>
      <div v-if="!goodsDetail.isCollect" class="item clickable" @click="changeCollect(true)">
        <img class="icon icon3" src="./img/collect.png" alt="">
        <span class="text">收藏</span>
      </div>
      <div v-if="goodsDetail.isCollect" class="item clickable" @click="changeCollect(false)">
        <img v-if="" class="icon icon3" src="./img/is-collect.png" alt="">
        <span class="text">已收藏</span>
      </div>
      <div class="item clickable" @click="goMy">
        <img class="icon icon4" src="./img/my.png" alt="">
        <span class="text">我的</span>
      </div>
    </div>
    <div class="btn-con" v-if="!goodsDetail.purchaseGoods">
      <div class="btn" v-if="$route.query.courseType===null " @click="queryWalletPass">购买专栏</div>
      <div class="btn" v-if="$route.query.courseType==='VIDEO' || $route.query.courseType==='AUDIO'" @click="queryWalletPass">{{ buyText }}</div>
      <div class="btn" v-if="$route.query.courseType==='LIVE_VOICE' || $route.query.courseType==='LIVE_IMAGE_TEXT' || $route.query.courseType==='LIVE_EDUCATION' || $route.query.courseType==='LIVE_INTERACTIVE_VIDEO'"
           @click="queryWalletPass">购买直播</div>
    </div>

    <div class="btn-con" v-if="goodsDetail.purchaseGoods">
      <div class="btn is-buy" v-if="!goodsDetail.roomId">已购买</div>
      <div class="btn go-live-room" v-if="goodsDetail.roomId" @click="goAppLiveRoom">进入直播间</div>
    </div>

    <van-popup
        v-model="setWalletPass"
        :close-on-click-overlay="false"
        get-container="#app"
        :style="{width: '90%', height: '48%'}"
    >
      <set-wallet-pass @setPass="setPass" />
    </van-popup>

  </div>
</template>

<script>
import { getCashWallet } from '@/api/wallet/cash'
import setWalletPass from '@/components/setWalletPass'
import {mapState,mapGetters,mapActions} from 'vuex';
export default {
  components: {
    setWalletPass,
  },
  data(){
    return {
      setWalletPass: false,//设置钱包密码
      goodsData: {},
      previewReqData: {},
      buyText: '购买课程'
    }
  },
  computed: {
    ...mapGetters([
      'goodsDetail',
      'shopDetail'
    ])
  },
  created(){
    if(this.goodsDetail.courseSeriesGoodsId){ // 当该课程为专栏下的课程时，按钮显示购买专栏，并把该按钮的跳转链接中的 goodsId 修改为所属专栏的 goodsId。
      this.buyText = '购买专栏'
    }
  },
  methods: {
    // 跳转至店铺主页
    goMallShop(){
      let mallShopPageQuery = {shopId: this.$route.query.shopId || this.shopDetail.shopId };
      if(this.$route.query.inviteUserId){
        mallShopPageQuery.inviteUserId = this.$route.query.inviteUserId
      }
      this.$router.push({name: 'mallShop', query: mallShopPageQuery })
    },
    goMy(){
      this.$router.push({name: 'my'})
    },
    // 收藏、取消收藏
    changeCollect(isCollect){
      this.$store.dispatch('mall/changeGoodsCollect', {
        goodsId: this.$route.query.goodsId,
        shopId: this.$route.query.shopId || this.shopDetail.shopId,
        isCollect: isCollect
      })
    },


    // 跳转至下单预览
    orderPreview(){
      if(this.goodsDetail.courseSeriesGoodsId){ //该课程属于专栏, 需要处理购买时的 goodsId 为所属专栏的 goodsId
        let query = {
          goodsId: this.goodsDetail.courseSeriesGoodsId,///-----
          shopId: this.$route.query.shopId,
          courseType: null,// 修改 为专栏的 null
        };
        this.$route.query.inviteUserId && (query.inviteUserId = this.$route.query.inviteUserId);
        this.$router.push({name: 'orderPreview',query})
      }else {
        this.$router.push({name: 'orderPreview',query: this.$route.query})
      }
    },

    // 下载APP弹出框
    goAppLiveRoom(){
      let courseType = this.goodsDetail.courseType;
      let query = {
        goodsId: this.goodsDetail.goodsId,
        shopId: this.goodsDetail.shopId,
        inviteUserId: this.session('userOpenId')
      };
      switch (courseType){
        case 'LIVE_VOICE': // 语音直播
        case 'LIVE_INTERACTIVE_VIDEO':// 视频直播
          this.$router.push({name: 'vedioLive', query });
          break;
        case 'LIVE_IMAGE_TEXT'://图文直播
          this.$router.push({name: 'picLive', query });
          break;
        default:
          //其他直播在APP中观看
          this.appDownload()
          break;
      }
    },



    // 获取钱包信息
    queryWalletPass(){
      getCashWallet({userOpenid: this.session('userOpenId'), walletType:0}).then(res => {
        if(res.code===200){
          if(res.data.payPassword !== '1'){ //没有密码
            // this.$toast('请设置支付密码!')
            this.setWalletPass = true;
          }else {
            this.orderPreview()
          }
        }
      })
    },
    // 子组件 setWalletPass 触发的方法
    setPass(data){
      if(data==='ok'){
        this.setWalletPass = false;
        this.orderPreview() //触发下单操作
      }
    },


  }
}
</script>

<style lang="less" scoped>
.buy-bottom{
  position: fixed;
  z-index: 1099;
  bottom: 0;
  left: 0;
  right: 0;
  height: 50px;
  display: flex;
  border-top: 1px solid #f5f5f5;
  background-color: #fff;
  .item-con{
    width: 158px;
    display: inline-flex;
    font-size: 10px;
    color: #999;
    .item{
      display: inline-flex;
      width: 30px;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      flex: 1;
      .icon{
        display: block;
      }
      .icon1{
        width: 17px;
        height: 17px;
      }
      .icon2{
        width: 20px;
        height: 17px;
      }
      .icon3{
        width: 18px;
        height: 17px;
      }
      .icon4{
        width: 20px;
        height: 20px;
      }
      .text{
        padding-top: 2px;
      }
    }
  }
  .btn-con{
    font-size: 16px;
    color: #fff;
    display: inline-flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    .btn{
      background-color: #f74646;
      border-radius: 5px;
      width: 205px;
      height: 35px;
      line-height: 35px;
      text-align: center;
    }
    .is-buy{background-color: #969799}
    .go-live-room{background-color: #1989fa}
  }
}
</style>